import currency, { Constructor } from 'currency.js'

// NOTE this is explicitly exported as an arrow function to preserve the namespace yping of the currency object
export const asCurrency = (val: string | number | typeof asCurrency, errorOnInvalid = true) => {
  // if (typeof val !== 'number' && typeof val !== 'string' && typeof val !== 'object') return NaN
  const decimal = typeof val === 'object' ? val.decimal : typeof val === 'number' || (val.indexOf(',') < val.indexOf('.') && val.indexOf(',') !== -1) || (val.indexOf(',') === -1 && val.indexOf('.') !== -1) ? '.' : ','
  const separator = typeof val === 'object' ? val.separator : decimal === '.' ? ',' : '.'
  // console.log('asCurrency -> ', val, decimal, currency(val, { separator: decimal === '.' ? ',' : '.', decimal }))
  return currency(val as string, { separator, decimal, errorOnInvalid })
}
